export class ModelSummaryProgram {
  constructor(
    public hash: string,
    public startTime: number,
    public programHash: string,
    public programReference: string,
    public programTime: number,
    public programTool: string,
    public programToolHolder: string,
    public printHash: string,
    public printReference: string,
    public manufacturingOrderHash: string,
    public manufacturingOrderCode: string,
    public manufacturingOrderCustomer: string,
    public manufacturingOrderSubCustomer: string,
    public manufacturingOrderReference: string,
    public manufacturingOrderProject: string,
    public manufacturingOrderIsPdfExist: boolean,
    public manufacturingOrderIsClaimed: boolean,
    public manufacturingOrderIsDeliveryChanged: boolean,
    public materialHash: string,
    public materialDenomination: string,
    public materialFileName: string,
    public operationHash: string,
    public operationName: string,
    public sourceHash: string,
    public sourceName: string,
    public partHash: string,
    public partName: string,
    public processCode: string,
    public timeDiff: number
  ) { }

  get sourcePart() {
    return (this.partName) ? `${ this.sourceName } - ${ this.partName }` : this.sourceName;
  }

  get correctedStartTime() {
    return this.startTime - this.timeDiff;
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/summary/model-summary-program.ts